import '../scss/style.scss';
import { initScrollTrigger } from './scroll-trigger.js';

document.addEventListener('DOMContentLoaded', () => {
  console.log('BusTaxi theme loaded');

  // ========== スクロールトリガーアニメーション ==========
  initScrollTrigger();

  // ========== ハンバーガーメニュー ==========
  const menuToggle = document.querySelector('.menu-toggle');
  const mobileMenu = document.getElementById('mobile-menu');

  function openMobileMenu() {
    menuToggle.setAttribute('aria-expanded', 'true');
    mobileMenu.classList.add('is-open');
    mobileMenu.setAttribute('aria-hidden', 'false');
    siteHeader.classList.add('menu-is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeMobileMenu() {
    menuToggle.setAttribute('aria-expanded', 'false');
    mobileMenu.classList.remove('is-open');
    mobileMenu.setAttribute('aria-hidden', 'true');
    siteHeader.classList.remove('menu-is-open');
    document.body.style.overflow = '';
  }

  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', () => {
      const isOpen = menuToggle.getAttribute('aria-expanded') === 'true';
      isOpen ? closeMobileMenu() : openMobileMenu();
    });

    // メニュー内リンクをクリックしたら閉じる（言語ボタンは除外）
    mobileMenu.querySelectorAll('a').forEach((link) => {
      if (link.classList.contains('mobile-menu__btn--language')) return;
      link.addEventListener('click', closeMobileMenu);
    });

    // ESCキーで閉じる
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && mobileMenu.classList.contains('is-open')) {
        closeMobileMenu();
        menuToggle.focus();
      }
    });

    // mobile-menu__inner以外をクリックしたら閉じる
    mobileMenu.addEventListener('click', (e) => {
      if (!e.target.closest('.mobile-menu__inner')) {
        closeMobileMenu();
      }
    });
  }

  // ========== TOPヘッダー スクロール制御 ==========
  const siteHeader = document.querySelector('.site-header');
  const hero = document.querySelector('.p-hero');

  if (siteHeader && hero) {
    const onScroll = () => {
      const heroBottom = hero.getBoundingClientRect().bottom;
      siteHeader.classList.toggle('is-scrolled', heroBottom <= 0);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll(); // 初期状態を反映
  }

  // ========== 言語切替ボタン ==========
  const gtSelector = document.querySelector('.gt_selector');

  if (gtSelector) {
    // 言語切替の共通処理
    function switchLang(opt) {
      if (!opt.value) {
        const exp = 'expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
        const host = location.hostname;
        const rootHost = host.replace(/^www\./, '');
        document.cookie = 'googtrans=; ' + exp;
        document.cookie = 'googtrans=; ' + exp + ' domain=' + host + ';';
        document.cookie = 'googtrans=; ' + exp + ' domain=.' + host + ';';
        document.cookie = 'googtrans=; ' + exp + ' domain=' + rootHost + ';';
        document.cookie = 'googtrans=; ' + exp + ' domain=.' + rootHost + ';';
        location.reload();
        return;
      }
      const gtContainer = document.querySelector('[class*="gt_container-"]');
      if (gtContainer) {
        gtContainer.dispatchEvent(new PointerEvent('pointerenter', { bubbles: true }));
      }
      gtSelector.value = opt.value;
      gtSelector.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // ===== ヘッダー用フローティングドロップダウン =====
    const langDropdown = document.createElement('div');
    langDropdown.className = 'language-dropdown';
    langDropdown.setAttribute('aria-hidden', 'true');
    langDropdown.setAttribute('role', 'menu');

    Array.from(gtSelector.options).forEach((opt) => {
      const item = document.createElement('button');
      item.type = 'button';
      item.className = 'language-dropdown__item';
      item.setAttribute('role', 'menuitem');
      item.textContent = opt.text;
      item.addEventListener('click', () => {
        closeLangDropdown();
        switchLang(opt);
      });
      langDropdown.appendChild(item);
    });

    document.body.appendChild(langDropdown);

    function openLangDropdown(triggerEl) {
      const rect = triggerEl.getBoundingClientRect();
      langDropdown.style.top = (rect.bottom + 8) + 'px';
      langDropdown.style.left = rect.left + 'px';
      langDropdown.setAttribute('aria-hidden', 'false');
      langDropdown.classList.add('is-open');
    }

    function closeLangDropdown() {
      langDropdown.setAttribute('aria-hidden', 'true');
      langDropdown.classList.remove('is-open');
    }

    const headerLangBtn = document.querySelector('.header-btn--language');
    if (headerLangBtn) {
      headerLangBtn.addEventListener('click', (e) => {
        e.preventDefault();
        closeLangDropdown();
        switchLang({ value: '' });
      });
    }

    document.addEventListener('click', (e) => {
      if (
        !e.target.closest('.header-btn--language') &&
        !e.target.closest('.language-dropdown')
      ) {
        closeLangDropdown();
      }
    });

    // ===== モバイル用インラインアコーディオン =====
    const mobileLangBtn = document.querySelector('.mobile-menu__btn--language');
    if (mobileLangBtn) {
      const mobileInlineList = document.createElement('div');
      mobileInlineList.className = 'mobile-lang-list';
      mobileInlineList.setAttribute('aria-hidden', 'true');

      Array.from(gtSelector.options).forEach((opt) => {
        const item = document.createElement('button');
        item.type = 'button';
        item.className = 'mobile-lang-list__item';
        item.textContent = opt.text;
        item.addEventListener('click', () => switchLang(opt));
        mobileInlineList.appendChild(item);
      });

      mobileLangBtn.insertAdjacentElement('afterend', mobileInlineList);

      mobileLangBtn.addEventListener('click', (e) => {
        e.preventDefault();
        const isOpen = mobileInlineList.classList.contains('is-open');
        mobileInlineList.classList.toggle('is-open', !isOpen);
        mobileInlineList.setAttribute('aria-hidden', isOpen ? 'true' : 'false');
        mobileLangBtn.classList.toggle('is-active', !isOpen);
      });
    }
  }

  // ========== GRAND BLUE ページ ヘッダー スクロール制御 ==========
  const pageGrandBlue = document.querySelector('.page-grand-blue');
  if (pageGrandBlue) {
    const gbSiteHeader = pageGrandBlue.querySelector('.site-header');
    if (gbSiteHeader) {
      const onScroll = () => {
        const scrolled = window.scrollY >= window.innerHeight;
        gbSiteHeader.classList.toggle('is-change', scrolled);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll(); // 初期状態を反映
    }

    // ========== GRAND BLUE Features 画像・リスト連動 ==========
    const featuresImages = pageGrandBlue.querySelector('.p-gb-features__images');
    const featureItems = pageGrandBlue.querySelectorAll('.p-gb-features__item');

    if (featuresImages && featureItems.length > 0) {
      const updateActiveImage = () => {
        featureItems.forEach((item, index) => {
          const itemTop = item.getBoundingClientRect().top;
          const windowCenter = window.innerHeight / 3; // ビューポート上部1/3位置

          // アイテムがビューポート上部に揃っているか判定
          const isAligned = Math.abs(itemTop - windowCenter) < 100;

          if (isAligned) {
            // 同じインデックスの画像に is-active を付与
            const imageIndex = index + 1;
            const image = featuresImages.querySelector(`.p-gb-features__image-${imageIndex}`);
            if (image) {
              featuresImages.querySelectorAll('.p-gb-features__image').forEach(img => {
                img.classList.remove('is-active');
              });
              image.classList.add('is-active');
            }
          }
        });
      };

      window.addEventListener('scroll', updateActiveImage, { passive: true });
      updateActiveImage(); // 初期状態を反映
    }
  }

  // ========== バスモーダル ==========
  let lastFocusedEl = null;

  function openModal(modal) {
    modal.setAttribute('aria-hidden', 'false');
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    // フォーカスを閉じるボタンへ
    const closeBtn = modal.querySelector('.js-modal-close');
    if (closeBtn) closeBtn.focus();
  }

  function closeModal(modal) {
    modal.setAttribute('aria-hidden', 'true');
    modal.classList.remove('is-open');
    document.body.style.overflow = '';
    if (lastFocusedEl) lastFocusedEl.focus();
  }

  // 「詳しく見る」ボタン
  document.querySelectorAll('.js-bus-modal-open').forEach((btn) => {
    btn.addEventListener('click', () => {
      const id = btn.dataset.busId;
      const modal = document.getElementById(`bus-modal-${id}`);
      if (!modal) return;
      lastFocusedEl = btn;
      openModal(modal);
      initModalSlider(modal);
    });
  });

  // 閉じる（オーバーレイクリック・閉じるボタン）
  document.querySelectorAll('.p-bus-modal').forEach((modal) => {
    // 閉じるボタン
    modal.querySelectorAll('.js-modal-close').forEach((btn) => {
      btn.addEventListener('click', () => closeModal(modal));
    });
    // オーバーレイ（モーダル自身の背景部分をクリック）
    modal.addEventListener('click', (e) => {
      if (e.target === modal) closeModal(modal);
    });
  });

  // ESCキー
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    const openModals = document.querySelectorAll('.p-bus-modal.is-open');
    openModals.forEach((m) => closeModal(m));
  });

  // モーダル内スライダー（モーダルが開かれた時に初期化）
  function initModalSlider(modal) {
    const slides = modal.querySelectorAll('.p-bus-modal__slide');
    const currentEl = modal.querySelector('.js-modal-current');
    const prevBtn = modal.querySelector('.js-modal-prev');
    const nextBtn = modal.querySelector('.js-modal-next');

    if (slides.length <= 1 || modal.dataset.sliderInit) return;
    modal.dataset.sliderInit = '1';

    let current = 0;

    const update = () => {
      slides.forEach((s, i) => s.classList.toggle('is-active', i === current));
      if (currentEl) currentEl.textContent = String(current + 1).padStart(2, '0');
      if (prevBtn) prevBtn.disabled = current === 0;
      if (nextBtn) nextBtn.disabled = current === slides.length - 1;
    };

    prevBtn?.addEventListener('click', () => { if (current > 0) { current--; update(); } });
    nextBtn?.addEventListener('click', () => { if (current < slides.length - 1) { current++; update(); } });

    update();
  }

  // ========== タクシーモーダル ==========
  // 「お問い合わせ」ボタン
  document.querySelectorAll('.js-taxi-modal-open').forEach((btn) => {
    btn.addEventListener('click', () => {
      const id = btn.dataset.taxiId;
      const modal = document.getElementById(`taxi-modal-${id}`);
      if (!modal) return;
      lastFocusedEl = btn;
      openModal(modal);
      initTaxiModalSlider(modal);
    });
  });

  // 閉じる
  document.querySelectorAll('.p-taxi-modal').forEach((modal) => {
    modal.querySelectorAll('.js-taxi-modal-close').forEach((btn) => {
      btn.addEventListener('click', () => closeModal(modal));
    });
    modal.addEventListener('click', (e) => {
      if (e.target === modal) closeModal(modal);
    });
  });

  // ESCキー（タクシーモーダル）
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.p-taxi-modal.is-open').forEach((m) => closeModal(m));
  });

  // タクシーモーダル内スライダー
  function initTaxiModalSlider(modal) {
    const slides = modal.querySelectorAll('.p-taxi-modal__slide');
    const currentEl = modal.querySelector('.js-taxi-modal-current');
    const prevBtn = modal.querySelector('.js-taxi-modal-prev');
    const nextBtn = modal.querySelector('.js-taxi-modal-next');

    if (slides.length <= 1 || modal.dataset.sliderInit) return;
    modal.dataset.sliderInit = '1';

    let current = 0;

    const update = () => {
      slides.forEach((s, i) => s.classList.toggle('is-active', i === current));
      if (currentEl) currentEl.textContent = String(current + 1).padStart(2, '0');
      if (prevBtn) prevBtn.disabled = current === 0;
      if (nextBtn) nextBtn.disabled = current === slides.length - 1;
    };

    prevBtn?.addEventListener('click', () => { if (current > 0) { current--; update(); } });
    nextBtn?.addEventListener('click', () => { if (current < slides.length - 1) { current++; update(); } });

    update();
  }

  // タクシー画像スライダー（一覧）
  document.querySelectorAll('.c-lineup-item.p-taxi-item').forEach((item) => {
    const slides = item.querySelectorAll('.c-slider__slide');
    const currentEl = item.querySelector('.js-taxi-slide-current');
    const prevBtn = item.querySelector('.js-taxi-slide-prev');
    const nextBtn = item.querySelector('.js-taxi-slide-next');

    if (slides.length <= 1) {
      if (prevBtn) prevBtn.disabled = true;
      if (nextBtn) nextBtn.disabled = true;
      return;
    }

    let current = 0;

    const update = () => {
      slides.forEach((s, i) => s.classList.toggle('is-active', i === current));
      if (currentEl) currentEl.textContent = String(current + 1).padStart(2, '0');
      if (prevBtn) prevBtn.disabled = current === 0;
      if (nextBtn) nextBtn.disabled = current === slides.length - 1;
    };

    prevBtn?.addEventListener('click', () => { if (current > 0) { current--; update(); } });
    nextBtn?.addEventListener('click', () => { if (current < slides.length - 1) { current++; update(); } });

    update();
  });

  // ========== GRAND BLUE FAQ アコーディオン ==========
  document.querySelectorAll('.js-faq-question').forEach((question) => {
    question.addEventListener('click', () => {
      const item = question.closest('.js-faq-item');
      if (!item) return;
      item.classList.toggle('is-open');
    });
  });

  // バス画像スライダー（一覧）
  document.querySelectorAll('.c-lineup-item.p-bus-item').forEach((item) => {
    const slides = item.querySelectorAll('.c-slider__slide');
    const currentEl = item.querySelector('.js-slide-current');
    const prevBtn = item.querySelector('.js-slide-prev');
    const nextBtn = item.querySelector('.js-slide-next');

    if (slides.length <= 1) {
      if (prevBtn) prevBtn.disabled = true;
      if (nextBtn) nextBtn.disabled = true;
      return;
    }

    let current = 0;

    const update = () => {
      slides.forEach((s, i) => s.classList.toggle('is-active', i === current));
      if (currentEl) currentEl.textContent = String(current + 1).padStart(2, '0');
      if (prevBtn) prevBtn.disabled = current === 0;
      if (nextBtn) nextBtn.disabled = current === slides.length - 1;
    };

    prevBtn?.addEventListener('click', () => { if (current > 0) { current--; update(); } });
    nextBtn?.addEventListener('click', () => { if (current < slides.length - 1) { current++; update(); } });

    update();
  });
});
